var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.access.Act_New)?_c('kst-form',{staticClass:"block",attrs:{"no-bezel":""},scopedSlots:_vm._u([{key:"top-right",fn:function(){return [_c('kst-button',{staticClass:"is-primary",attrs:{"action-mode":"","full-label":"","module":_vm.Model.Module,"moduleType":_vm.Model.ModuleType.New}})]},proxy:true}],null,false,19747298)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }